function initInfiniteScroll() {
  let isLoading = false; 

  const $collectionWrapper = document.querySelector('.collection.page-width');
  if (!$collectionWrapper) return;

  const $infiniteScroll = $collectionWrapper.querySelector('#infinite-scroll');
  const $productsGrid = $collectionWrapper.querySelector('ul.product-grid');
  if (!$infiniteScroll || !$productsGrid) return;

  const $loader = $infiniteScroll.querySelector('.loader');

  function togglePrivateSaleElements() {
    const hasPrivateSale = sessionStorage.getItem('PrivateSale');
    if (!hasPrivateSale) return;

    var notPrivateSaleElements = document.querySelectorAll('.not-private-sale');
    var privateSaleElements = document.querySelectorAll('.private-sale-price');

    notPrivateSaleElements.forEach(function (element) {
      element.classList.add('hidden');
    });

    privateSaleElements.forEach(function (element) {
      element.classList.remove('hidden');
    });
  }

  function loadNextPage() {
    if (isLoading) return; 
    const { nextPaginationUrl } = $infiniteScroll.dataset;

    if (!nextPaginationUrl) return;

    isLoading = true; 
    $loader.classList.remove('hidden');

    fetch(nextPaginationUrl)
      .then((response) => response.text())
      .then((data) => {
        const $htmlPage = new DOMParser().parseFromString(data, 'text/html');
        const $nextPageProductsGrid =
          $htmlPage.querySelector('ul.product-grid');
        const nextPageProducts = Array.from($nextPageProductsGrid.children);

        const $firstNewProduct = nextPageProducts.find((el) => el.tagName === 'LI');

        nextPageProducts.forEach(($newProduct) =>
          $productsGrid.appendChild($newProduct)
        );

        const imagesList = Array.from(
          $nextPageProductsGrid.querySelectorAll('img[data-src]')
        );
        initLazyload(imagesList); // Essa função é declarada no global.js
        togglePrivateSaleElements();

        updatePagination($nextPageProductsGrid, $firstNewProduct);
        $loader.classList.add('hidden');
        isLoading = false; 
      });
  }

  function isPageAtBottom() {
    const tolerance = 100; // margem de tolerância
    const scrollPosition = Math.ceil(window.innerHeight + window.scrollY);
    const pageHeight = document.documentElement.scrollHeight;
    return scrollPosition >= pageHeight - tolerance;
  }

  function updatePagination($nextPageProductsGrid, $firstNewProduct) {
    const $nextPageInfiniteScroll =
      $nextPageProductsGrid.parentNode.querySelector('#infinite-scroll');
    const { nextPaginationUrl } = $nextPageInfiniteScroll.dataset;
    if (nextPaginationUrl) {
      // ainda não é a última página
      $infiniteScroll.setAttribute(
        'data-next-pagination-url',
        nextPaginationUrl
      );
      //Scroll até o primeiro produto da nova página carregada se a página estiver no final
      if ($firstNewProduct && isPageAtBottom()) {
        const scrollTop = -200
        $firstNewProduct.scrollIntoView({
          block: 'start'
        });
        // sobe para pegar um pedaço do produto de cima
        window.scrollBy(0, scrollTop);
      }

      return;
    }
    finishInfiniteScroll(); // é a última página
  }

  function finishInfiniteScroll() {
    $infiniteScroll.removeAttribute('data-next-pagination-url');
    $loader.classList.add('hidden');
    observer.unobserve($infiniteScroll);
  }

  function handleObserver(entries) {
    if (entries[0].isIntersecting) loadNextPage();
  }

  const offset = 100;
  const intersectionOptions = {
    root: null,
    rootMargin: offset + 'px',
    threshold: 0.1,
  };

  const observer = new IntersectionObserver(
    handleObserver,
    intersectionOptions
  );

  observer.observe($infiniteScroll);
}

initInfiniteScroll();
